import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function LatestNews() {
  const latestArticles = articles.slice(0, 3);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100">
              最新资讯
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              了解 galagame 平台最新动态与游戏资讯
            </p>
          </div>
          <Link
            to="/articles"
            className="hidden sm:inline-flex items-center gap-2 text-sm font-medium text-primary-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/50 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-0.5 text-[10px] font-medium rounded-full bg-accent-500/80 text-background-50">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
                  <span>{article.date}</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-600"></span>
                  <span>{article.readTime}阅读</span>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-100 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8 sm:hidden">
          <Link
            to="/articles"
            className="inline-flex items-center gap-2 px-6 py-2.5 text-sm font-semibold text-primary-500 border border-primary-500/30 hover:bg-primary-500/10 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部资讯
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}